module.exports = __webpack_public_path__ + "img/progress_071.0d03b4f7.png";